import React from 'react';
import QRCode from 'react-qr-code';

type Props = {
  ticket: {
    UUID: string;
    folio: string;
    evento: {
      nombre: string;
    };
  };
};

const QR_VERSION = '1.0.1';
const QR_EVENTO = 'fatima';

const TicketCard: React.FC<Props> = ({ ticket }) => {
  const qrData = JSON.stringify({
    ticketcash: ticket.UUID,
    folio: ticket.folio,
    version: QR_VERSION,
    evento: QR_EVENTO,
  });

  return (
    <div
      style={{
        backgroundColor: '#029037',
        borderRadius: '6px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        width: '340px',
        height: '125px',
        margin: '8px',
        overflow: 'hidden',
        boxSizing: 'border-box',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      {/* Zona izquierda — Logo Fiesta + Logo Afirme */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '110px',
          padding: '6px 4px',
          flexShrink: 0,
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/media/logos/LogoFiestaPatronal2026.png`}
          alt="Fiesta Patronal 2026"
          style={{ width: '108px', height: 'auto', objectFit: 'contain' }}
        />
        <img
          src={`${process.env.PUBLIC_URL}/media/logos/LogoAfirme.png`}
          alt="Afirme"
          style={{ width: '105px', height: 'auto', objectFit: 'contain', display: 'block' }}
        />
      </div>

      {/* Zona central — QR + Folio */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          justifyContent: 'center',
          flexGrow: 1,
          padding: '4px 6px 4px 0px',
          gap: '3px',
        }}
      >
        <div style={{ backgroundColor: '#fff', padding: '2px', display: 'inline-flex' }}>
          <QRCode value={qrData} size={90} />
        </div>
        <span
          style={{
            color: '#fff',
            fontSize: '8px',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            letterSpacing: '0.5px',
            alignSelf: 'center',
          }}
        >
          FOLIO: {ticket.folio}
        </span>
      </div>

      {/* Zona derecha — Ticketcash vertical (sin borde) */}
      <div
        style={{
          width: '22px',
          flexShrink: 0,
          position: 'relative',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%) rotate(90deg)',
            color: '#fff',
            fontSize: '8px',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            letterSpacing: '0.5px',
          }}
        >
          Ticketcash
        </span>
      </div>
    </div>
  );
};

export { TicketCard };
